import React from "react";

const LABELS = {
  live: "Live", scheduled: "Scheduled", ended: "Ended",
  to_ship: "To ship", shipped: "Shipped", delivered: "Delivered", refunded: "Refunded",
  open: "Open", answered: "Answered", resolved: "Resolved",
  reviewed: "Reviewed", actioned: "Actioned", dismissed: "Dismissed",
};

export function StatusPill({ status }) {
  if (!status) return null;
  return (
    <span className={`ss-pill pill--${status}`} data-testid={`status-${status}`}>
      {status === "live" && <span className="ss-dot" style={{ background: "currentColor" }} />}
      {LABELS[status] || status}
    </span>
  );
}
